import React, { useState } from "react";
import { sampleTimeSheetData } from "./ActivityCalendarData";
import { dateFormator } from "../../utils";
import Button from "../Buttons/Button";
import Divider from "../Common/Divider";
import Modal from "../Modal/Modal";
import FormFieldSet from "../FormFields/FormFieldSet";

const ActivityCalendar = ({ showPerPage = 3 }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");

  // Sort data by date (newest first)
  const sortedData = [...sampleTimeSheetData].sort((a, b) => {
    return new Date(b.dateTime) - new Date(a.dateTime);
  });

  // Calculate total pages
  const totalPages = Math.ceil(sortedData.length / showPerPage);

  // Get current items
  const indexOfLastItem = currentPage * showPerPage;
  const indexOfFirstItem = indexOfLastItem - showPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page navigation
  const goToNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const goToPrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const openModal = (description) => {
    setSelectedDescription(description);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDescription("");
  };

  return (
    <div className="flex flex-col gap-2 mt-5 m-0.5">
      <div className="flex justify-end ">
        <div className="max-w-2xl flex-1 flex justify-end gap-3">
          <div className="flex-1">
            <FormFieldSet
              type="datepicker"
              noTitle={true}
              placeholder="Select Date"
            />
          </div>
          <div className="flex-1">
            <FormFieldSet
              type="datepicker"
              noTitle={true}
              placeholder="Select Date"
            />
          </div>
          <div>
            <Button title={"Filter"} />
          </div>
        </div>
      </div>
      <div className="flex gap-2 .body-two mb-2">
        <span>Activities: Ramesh Manthri</span>
        <Divider orientation="vertical" />
        <span>CON-2064</span>
      </div>
      <div className="flex flex-col gap-4">
        {currentItems.map((data, index) => {
          return (
            <div
              key={index}
              className="p-3 shadow-activity-100 rounded flex gap-3"
            >
              <div className="w-20 aspect-square rounded overflow-hidden flex flex-col shadow-md">
                <div className="bg-primary text-center text-white font-semibold text-sm p-1 ">
                  {dateFormator(data.dateTime, "month")}{" "}
                </div>
                <div className="flex-1 flex items-center justify-center font-bold text-3xl">
                  {dateFormator(data.dateTime, "dateNum")}
                </div>
              </div>
              <div className="flex flex-col justify-between gap-1 ">
                <div className="flex flex-col gap-0.5">
                  <div className="info-text font-medium">{data.title}</div>
                  <div className="info-text font-normal text-primary flex gap-2">
                    <span>
                      {dateFormator(data.dateTime, "date/month/year")}
                    </span>
                    <span> {dateFormator(data.dateTime, "time-ampm")}</span>

                    {data.time}
                  </div>
                  <div className="info-text font-normal flex gap-2">
                    <span>{data.employee.name}</span>
                    <Divider orientation="vertical" />
                    <span>{data.employee.employeeId}</span>
                    <Divider orientation="vertical" />
                    <span>{data.employee.email}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="info-text font-medium">
                    {data.description}{" "}
                  </span>
                  <span className="info-text font-medium ">
                    {data.fullDescription && data.fullDescription !== "" ? (
                      <Button
                        variant="text"
                        size="sm"
                        color="info"
                        title={"show more"}
                        className="!p-0"
                        onClick={() => openModal(data.fullDescription)}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        })}

        {/* Pagination controls */}
        <div className="flex justify-end gap-10 items-center mt-0">
          <div className="text-sm">
            Page {currentPage} of {totalPages}
          </div>
          <div className="flex gap-2 justify-center items-center">
            <Button
              type="icon"
              icon="chevron_left"
              size="sm"
              color="black"
              variant="text"
              onClick={goToPrevPage}
              disabled={currentPage === 1}
            />
            <Button
              type="icon"
              icon="chevron_right"
              size="sm"
              color="black"
              variant="text"
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
            />
          </div>
          {/* <button
          onClick={goToPrevPage}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded ${
            currentPage === 1
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-primary text-white hover:bg-primary-dark"
          }`}
        >
          Prev
        </button> */}

          {/* <button
          onClick={goToNextPage}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded ${
            currentPage === totalPages
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-primary text-white hover:bg-primary-dark"
          }`}
        >
          Next
        </button> */}
        </div>
      </div>

      {/* Modal for displaying full description */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Full Description"
        width="max-w-3xl"
      >
        <div className="p-4">
          <p className="text-base">{selectedDescription}</p>
          <div className="mt-4 flex justify-end">
            <Button title="Close" color="primary" onClick={closeModal} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ActivityCalendar;
